
export default "/assets/face-smile-micro.7fc3ea9c.svg"